module.exports = __webpack_public_path__ + "img/homepage_0--mobile@2x.835ef83d.jpg";